export default "__VITE_ASSET__CdLD06E2__"